export default __webpack_public_path__ + "static/media/banner2.9020569d.jpg";